import React, { useContext } from "react";
import PropTypes from "prop-types";
import { MonetateContext } from "../../../../context/MonetateContext";
import styles from "./opening-hours.module.scss";

function OpeningHours({ openingHours }) {
  const { liveChatProminenceExperiment } = useContext(MonetateContext);

  const { days, times } = openingHours[0] || {};

  const formatTimeRange = times => {
    return times
      .replace(/\s*-\s*/g, "-")
      .replace(/:00(?=[ap]m)/gi, "")
      .replace(/^0+/, "")
      .replace(/-0+/, "-");
  };

  return (
    <div>
      {liveChatProminenceExperiment ? (
        <>
          {openingHours.length > 1 ? (
            <ul className={styles["opening-hours__multiline-availability"]}>
              {openingHours.map(({ days, times }) => (
                <li key={days} className={styles["opening-hours__availability-li"]}>
                  <span className={styles["opening-hours__days"]}>{`${days}, `}</span>
                  <span className={styles["opening-hours__hours"]}>{formatTimeRange(times)}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className={styles["opening-hours__single-availability"]}>
              <span>
                Available {days}, {formatTimeRange(times)}
              </span>
            </p>
          )}
        </>
      ) : (
        <>
          {openingHours.length > 1 ? (
            <ul className={styles["opening-hours__multiline-availability"]}>
              {openingHours.map(({ days, times }) => (
                <li key={days} className={styles["opening-hours__availability-line"]}>
                  <span className={styles["opening-hours__days"]}>{days}</span>
                  <span className={styles["opening-hours__hours"]}>{times}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p className={styles["opening-hours__single-availability"]}>
              <span className={styles["opening-hours__days"]}>{openingHours[0].days}</span>
              <span className={styles["opening-hours__hours"]}>{openingHours[0].times}</span>
            </p>
          )}
        </>
      )}
    </div>
  );
}

OpeningHours.propTypes = {
  openingHours: PropTypes.arrayOf(PropTypes.any).isRequired,
};

OpeningHours.defaultProps = {};

export default OpeningHours;
